import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { useState, useEffect, useMemo } from 'react';
import RecentChartList from './RecentChartList';
import { post } from '../Auths/AuthToken';
import { COMMUNICATION_TAB, DEFAULT_LOCAL_PATH } from '../../constents';
import AppPopup from '../Schedular/Appointment/AppPopup';
import PatientSerchPopUpForApp from '../PatientSerchPopUpForApp';
import PatientMainSerch from '../PatientMainSerch';
import setUiMessage from '../../Utilities/Tostify';
import { debounce } from 'lodash';
import UploadDocPopUp from '../Documents/UploadDocPopUp';
import PatientDemoPopUp from '../Patient/PatientDemoPopUp';
import CommunicationCurtain from '../Communication/Communication curtain/CommunicationCurtain';
import ComSelectRecipentPopUp from '../Communication/ComSelectRecipentPopUp';
import ComPatientComposeText from '../Communication/ComPatientComposeText';
import ComPatientEmailCompose from '../Communication/ComPatientEmailCompose';
import ComStaffMsgCompose from '../Communication/ComStaffMsgCompose';
import ChangePasswordPopup from '../Auths/ChangePassword';
import { MdLogout } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import {
  setGrpApp,
  setAppPopup,
  setGrpAppPatsNull,
  handReSchedule,
  bookNewAppWithApp,
  setAppPatSerchPopup,
  setGlobalAppId,
  setAppPrecurrencePopup,
  setIsCheckoutProcess,
  setGrpAppArivedPats,
  setPatSrchDiasbled,
} from '../../redux/slices/scheduler/appointmentSlice';
import { setMessageCount } from '../../redux/slices/communicationSlice';
import { logout, setAuthUser } from '../../redux/slices/auth/authSlice';
import { setSeltSerchPat } from '../../redux/slices/patient/patientSlice';

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { appPopup, globalAppId, appPatSerchPopup } = useSelector(
    (store) => store.appointment,
  );
  const { patient } = useSelector((store) => store.patient);
  const { comMsg } = useSelector((store) => store.communication);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [openRecentCart, setOpenRecentCart] = useState(false);
  const [recentChartList, setRecentChartList] = useState([]);
  const [input, setInput] = useState('');
  const [openPatSerchMainPopup, setOpenPatSerchMainPopup] = useState(false);
  const [patList, setPatList] = useState(null);
  const [openAddEditPopup, setOpenAddEditPopup] = useState(false);
  const [patPopup, setPatPopup] = useState(false);
  const [, setReload] = useState(false);
  const [comCurtainPopup, setComCurtainPopup] = useState(false);
  const [selRecipentPopUp, setSelRecipentPopUp] = useState(false);
  const [patTextPopUp, setPatTextPopup] = useState(false);
  const [patEmailPopUp, setPatEmailPopUp] = useState(false);
  const [patSecureEmailPopUp, setPatSecureEmailPopUp] = useState(false);
  const [staffMsgPopUp, setStaffMsgPopUp] = useState(false);
  const [chanePasswd, setChanePasswd] = useState(false);
  const { pathname } = useLocation();

  const lastSegment = useMemo(() => {
    const segments = pathname.split('/');
    return segments[segments.length - 1];
  }, [pathname]);

  const handleReload = () => setReload((prev) => !prev);

  const handleLogout = () => setDialogOpen(true);

  const handleAppOpen = (serchPopupOpen = true, data = null) => {
    setOpenPatSerchMainPopup(false);
    if (serchPopupOpen) dispatch(setAppPatSerchPopup(true));
    dispatch(
      setSeltSerchPat(
        data
          ? {
              patId: data.userId,
              getPatientType: data.getPatientType,
              getNewPatientType: data.getNewPatientType,
              patName: data.patName,
            }
          : {},
      ),
    );
    dispatch(setGrpApp(false));
    dispatch(setAppPopup(true));
  };

  const handlePatientSerchList = (e) => setInput(e.target.value);
  const debouncedInputData = useMemo(
    () => debounce(handlePatientSerchList, 500),
    [],
  );

  useEffect(() => {
    if (input) {
      setOpenPatSerchMainPopup(true);
      const fetchData = async () => {
        try {
          const response = await post(
            'api/appointment/appointment/listOfPatient',
            {
              searchStr: input,
              searchCritaria: 'any',
            },
          );
          if (response.status === 200) setPatList(response.data.patList);
        } catch (err) {
          setUiMessage('error', err.message);
        }
      };
      fetchData();
    } else {
      setPatList(null);
    }
  }, [input]);

  useEffect(() => {
    const fetchRecentSearchPatients = async () => {
      try {
        const response = await post(
          'api/patient/patient/getAllRecentSearchPatientList',
          {
            userStaffId: user?.id,
          },
        );
        if (response.status === 200) {
          setRecentChartList(response.data.recentsearchPatientList);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    };
    fetchRecentSearchPatients();
  }, [user?.id, patient]);

  useEffect(() => {
    const fetchUnreadMessagesCount = async () => {
      try {
        const response = await post(
          'api/communication/Communication/countUnreadMessage',
          {
            loginId: user?.id,
          },
        );
        if (response.status === 200) {
          dispatch(setMessageCount(response.data.totalCnt || 0));
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    };
    fetchUnreadMessagesCount();
  }, [user?.id, dispatch]);

  const handleDialogSuccess = () => {
    localStorage.clear();
    dispatch(logout());
    dispatch(setAuthUser(null));
    navigate(`${DEFAULT_LOCAL_PATH}`);
  };

  const handleExternalLink = (url) => (event) => {
    event.preventDefault();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <header className="hideq">
      <section>
        <div className="product-Logo">
          <NavLink to={`${DEFAULT_LOCAL_PATH}/scheduler`}>
            <img src="./images/smallLogo.png" className="App-logo" alt="logo" />
          </NavLink>
        </div>
        <menu>
          <span className="menu-item">
            <NavLink
              to={`${DEFAULT_LOCAL_PATH}/scheduler`}
              className={({ isActive }) => (isActive ? 'menu-item-active' : '')}
            >
              Scheduler
            </NavLink>
          </span>
          <span className="menu-item">
            <ul>
              <li className="dropdown">
                <NavLink
                  to={`${DEFAULT_LOCAL_PATH}/patient`}
                  className={({ isActive }) =>
                    isActive ? 'menu-item-active' : ''
                  }
                >
                  Patient
                </NavLink>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink
                      to={`${DEFAULT_LOCAL_PATH}/patient`}
                      className={({ isActive }) =>
                        isActive ? 'menu-item-active' : ''
                      }
                    >
                      Patient
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={`${DEFAULT_LOCAL_PATH}/patient/intake`}
                      className={({ isActive }) =>
                        isActive ? 'menu-item-active' : ''
                      }
                    >
                      Intake
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={`${DEFAULT_LOCAL_PATH}/patient/referral`}
                      className={({ isActive }) =>
                        isActive ? 'menu-item-active' : ''
                      }
                    >
                      Referral
                    </NavLink>
                  </li>
                </ul>
              </li>
            </ul>
          </span>
          <span className="menu-item">
            <NavLink
              to={`${DEFAULT_LOCAL_PATH}/documents`}
              className={({ isActive }) => (isActive ? 'menu-item-active' : '')}
            >
              Documents
            </NavLink>
          </span>
          <span className="menu-item">
            <NavLink
              to={`${DEFAULT_LOCAL_PATH}/notes`}
              className={({ isActive }) => (isActive ? 'menu-item-active' : '')}
            >
              Notes
            </NavLink>
          </span>
          <span className="menu-item">
            <NavLink
              to={`${DEFAULT_LOCAL_PATH}/priorAuth`}
              className={({ isActive }) => (isActive ? 'menu-item-active' : '')}
            >
              Auth
            </NavLink>
          </span>
          <span className="menu-item">
            <ul>
              <li className="dropdown">
                <NavLink
                  to={`${DEFAULT_LOCAL_PATH}/report`}
                  className={({ isActive }) =>
                    isActive ? 'menu-item-active' : ''
                  }
                >
                  Report
                </NavLink>
                <ul className="dropdown-menu">
                  <li>
                    <NavLink
                      to={`${DEFAULT_LOCAL_PATH}/report/credentialing`}
                      className={({ isActive }) =>
                        isActive ? 'menu-item-active' : ''
                      }
                    >
                      Credentialing
                    </NavLink>
                  </li>
                </ul>
              </li>
            </ul>
          </span>
          {COMMUNICATION_TAB && (
            <span
              className="menu-item"
              style={{ qmarginTop: '-3px', cursor: 'pointer' }}
              onClick={() => {
                if (lastSegment !== 'communication') setComCurtainPopup(true);
              }}
            >
              Comm.
              <span className="main-unread-msg-cnt">{comMsg?.total}</span>
              <img className="hide" src="./images/envelop.png" alt="" />
            </span>
          )}
        </menu>
        <div className="patient-search">
          <input
            type="search"
            className="main-search"
            placeholder="Search Patient..."
            onChange={debouncedInputData}
          />
          {openPatSerchMainPopup && (
            <PatientMainSerch
              handleClose={() => setOpenPatSerchMainPopup(false)}
              patListArr={patList}
              handleAppOpen={handleAppOpen}
            />
          )}
        </div>
        <div className="user-login">
          <span className="user-pic">
            <img
              className="user-pic-dim img-hover-top"
              width="40px"
              height="40px"
              src={user?.imageNameStr || './images/user.jpg'}
              alt=""
            />
          </span>
          <span className="user-name">{user?.providerFullName}</span>
          <div className="dropdown">
            <span
              className="logout-arw"
              style={{ display: 'flex', margin: '15px 5px' }}
            >
              ▼
            </span>
            <ul
              className="dropdown-menu"
              style={{
                position: 'absolute',
                right: '0',
                left: 'unset',
                top: '30px',
              }}
            >
              <li>
                <span onClick={() => setChanePasswd(true)}>
                  Change Password
                </span>
              </li>
            </ul>
            {chanePasswd && (
              <ChangePasswordPopup onClose={() => setChanePasswd(false)} />
            )}
          </div>
          <span className="logout">
            <span className="logout-icn" onClick={handleLogout}>
              <MdLogout />
            </span>
            {dialogOpen && (
              <ConfirmDialog
                title={''}
                bodytext={`Do you want to log out?`}
                closeDialog={() => setDialogOpen(false)}
                successDialog={handleDialogSuccess}
              />
            )}
          </span>
        </div>
      </section>
      <section>
        <span className="quick-links" onClick={() => handleAppOpen(true)}>
          New Appointment
        </span>
        <span
          className="quick-links"
          onClick={() => {
            setOpenAddEditPopup(true);
            dispatch(setSeltSerchPat({}));
          }}
        >
          Upload Doc
        </span>
        {openAddEditPopup && (
          <UploadDocPopUp
            close={() => setOpenAddEditPopup(false)}
            handleReload={handleReload}
          />
        )}
        <span className="quick-links" onClick={() => setPatPopup(true)}>
          New patient
        </span>
        <span
          className="chart"
          onClick={() => setOpenRecentCart((prev) => !prev)}
        >
          <span className="">Charts</span>
          <span className="Charts-dd">&#9660;</span>
        </span>
        <span className="chart">
          <Link
            to="#"
            onClick={handleExternalLink('https://us06web.zoom.us/j/2331262140')}
          >
            Start a support call
          </Link>
        </span>
        <RecentChartList
          list={recentChartList}
          setOpenRecentCart={() => setOpenRecentCart(false)}
          isOpen={openRecentCart}
        />
      </section>
      {appPopup && (
        <AppPopup
          handleClose={() => {
            dispatch(setAppPopup(false));
            dispatch(setGlobalAppId(null));
            dispatch(
              handReSchedule({
                status: false,
                text: '',
                appStatusAutoId: 0,
                is_no_show_billed: '',
              }),
            );
            dispatch(bookNewAppWithApp({ status: false }));
            dispatch(
              setAppPrecurrencePopup({
                status: false,
                type: 0,
                recurringId: 0,
              }),
            );
            dispatch(
              setIsCheckoutProcess({
                status: false,
                appid: null,
                currentStatusAutoIncId: null,
              }),
            );
            dispatch(setGrpApp(false));
            dispatch(setSeltSerchPat({}));
            dispatch(setGrpAppPatsNull([]));
            dispatch(setGrpAppArivedPats([]));
            dispatch(setPatSrchDiasbled(false));
          }}
          handleOpenPatSerch={() => dispatch(setAppPatSerchPopup(true))}
          appId={globalAppId}
        />
      )}
      {appPopup && appPatSerchPopup && (
        <PatientSerchPopUpForApp
          handleClosePatSerch={() => dispatch(setAppPatSerchPopup(false))}
        />
      )}
      {patPopup && <PatientDemoPopUp handleClose={() => setPatPopup(false)} />}
      {comCurtainPopup && (
        <CommunicationCurtain
          close={() => setComCurtainPopup(false)}
          setSelRecipentPopUp={() => setSelRecipentPopUp(true)}
        />
      )}
      {selRecipentPopUp && (
        <ComSelectRecipentPopUp
          close={() => setSelRecipentPopUp(false)}
          setPatTextPopup={() => setPatTextPopup(true)}
          setPatEmailPopUp={() => setPatEmailPopUp(true)}
          setPatSecureEmailPopUp={() => setPatSecureEmailPopUp(true)}
          setStaffMsgPopUp={() => setStaffMsgPopUp(true)}
        />
      )}
      {patTextPopUp && (
        <ComPatientComposeText
          close={() => setPatTextPopup(false)}
          handleReload={handleReload}
        />
      )}
      {patEmailPopUp && (
        <ComPatientEmailCompose
          close={() => setPatEmailPopUp(false)}
          msgType={'1'}
          handleReload={handleReload}
        />
      )}
      {patSecureEmailPopUp && (
        <ComPatientEmailCompose
          close={() => setPatSecureEmailPopUp(false)}
          msgType={'0'}
          handleReload={handleReload}
        />
      )}
      {staffMsgPopUp && (
        <ComStaffMsgCompose
          close={() => setStaffMsgPopUp(false)}
          handleReload={handleReload}
        />
      )}
    </header>
  );
}

export default Header;
